import type { Table } from "@tanstack/react-table";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * Faol filtrlar qatori.
 *
 * Filtrlar ustun sarlavhasining ichida yashaydi — bu to'g'ri joy,
 * chunki filtr o'z ustunini ko'rsatib turadi. Lekin yopilgan
 * oynadan tashqarida u KO'RINMAYDI: ro'yxat bo'shab qolganda odam
 * "ma'lumot yo'q" deb o'ylaydi va yetti ustunni bittalab ochib
 * qidiradi.
 *
 * Shuning uchun tanlangan har bir filtr shu yerda nomi bilan turadi
 * va bittalab yoki birdan olib tashlanadi. Filtr yo'q bo'lsa qator
 * ham yo'q — bo'sh joy egallab turmaydi.
 */
export function ActiveFilters<TData>({
  table,
  className,
}: Readonly<{ table: Table<TData>; className?: string }>) {
  const { t } = useTranslation();

  const active = table
    .getState()
    .columnFilters.map(filter => {
      const column = table.getColumn(filter.id);
      if (!column) return null;

      const header = column.columnDef.header;
      const options = column.columnDef.meta?.filterOptions;
      const raw = String(filter.value ?? "");
      if (!raw) return null;

      return {
        id: filter.id,
        // Nishonda ustun nomi ham bor: "Faol" o'z-o'zicha qaysi
        // ustunga tegishli ekanini aytmaydi, "Holat: Faol" aytadi.
        label: typeof header === "string" ? header : filter.id,
        // Tanlov ro'yxatidagi qiymat KO'RINADIGAN nomi bilan
        // chiqadi: URL'dagi `succeeded` odam yozgan narsa emas.
        value: options?.find(option => option.value === raw)?.label ?? raw,
        clear: () => column.setFilterValue(undefined),
      };
    })
    .filter(item => item !== null);

  if (active.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap items-center gap-1.5", className)}>
      {active.map(item => (
        <span
          key={item.id}
          className="bg-secondary text-secondary-foreground inline-flex items-center gap-1 rounded-full py-0.5 pr-0.5 pl-2.5 text-xs"
        >
          <span className="text-muted-foreground">{item.label}:</span>
          <span className="font-medium">{item.value}</span>
          <button
            type="button"
            onClick={item.clear}
            aria-label={`${item.label} — ${t("common.reset")}`}
            className="hover:bg-background/80 focus-visible:ring-ring grid size-4.5 cursor-pointer place-items-center rounded-full transition-colors focus-visible:ring-2 focus-visible:outline-none"
          >
            <X className="size-3" />
          </button>
        </span>
      ))}

      {/* Ikkitadan boshlab: bitta filtrni tozalash uchun uning o'z
          xochi yetarli, yonidagi ikkinchi tugma faqat shovqin. */}
      {active.length > 1 && (
        <Button
          variant="ghost"
          size="sm"
          className="text-muted-foreground h-6 px-2 text-xs"
          onClick={() => table.resetColumnFilters()}
        >
          {t("table.clearFilters")}
        </Button>
      )}
    </div>
  );
}
